import React from "react";
import avatarDefault from "../images/avatar_default.png";
import avatarFemale from "../images/avatar_female.jpg";
import avatarMale from "../images/avatar_male.jpg";

export default function RaGenderField(props) {
    const { record, source, style } = props;

    let imageSrc = avatarDefault, avatarSize = 32;
    if (record) {
        if (typeof record[source] === "string" && ["female", "f"].includes(record[source].toLocaleLowerCase())) {
            imageSrc = avatarFemale;
            avatarSize = 34;
        } else if (typeof record[source] === "string" && ["male", "m"].includes(record[source].toLocaleLowerCase())) {
            imageSrc = avatarMale;
            avatarSize = 34;
        }
    }

    return (
        <div style={{ display: "flex", alignItems: "center", columnGap: 12, ...style }}>
            <img
                src={imageSrc}
                className="avatarField"
                alt="Avatar"
                style={{ width: avatarSize, height: avatarSize, ...style }}
            />
        </div>
    );
}